module.exports = __webpack_public_path__ + "static/media/test2_4.d21b38e6.png";